<template>
  <div id='mailer'>
    <v-menu
      offset-y
      v-model="menuMail"
      :close-on-content-click="false"
      :nudge-width="200"
      top
      :nudge-top="20"
    >

      <template v-if="registered" #activator="{ on: menuMail }">
        <v-tooltip bottom>
          <template #activator="{ on: tooltip }">
            <v-btn
              fab
              fixed bottom
              color="primary"
              class="pa-0 ma-0 text-xs-right"
              v-on="{ ...tooltip, ...menuMail }"
            >
              <v-icon>mail_outline</v-icon>
            </v-btn>
          </template>
          <span>{{ helpTooltip }}</span>
        </v-tooltip>
      </template>

      <template v-else #activator="{ on: menuMail }">
        <v-tooltip bottom>
          <template #activator="{ on: tooltip }">
            <v-btn
              flat outline
              color="white"
              v-on="{ ...tooltip, ...menuMail }"
            >
              <v-icon left>mail_outline</v-icon>
              contact
            </v-btn>
          </template>
          <span>{{ helpTooltip }}</span>
        </v-tooltip>
      </template>


      <v-card>
        <v-card-text class="primary white--text">
          <h3 class="headline text-xs-center">Contact</h3>
        </v-card-text>
        <v-card-text>
          <v-form @submit.prevent="menuMail = false">
            <v-text-field v-if="!registered"
              name="email-message"
              v-model="guestEmail"
              label="mail"
              prepend-icon="mail_outline"
              v-validate="'email'"
              data-vv-as="email"
              :error-messages="errors.collect('email-message')"
            >
            </v-text-field>
            <v-textarea
              outline
              v-model="message"
              name="mailsupport"
              label="Message"
              :hint="hinttext"
            ></v-textarea>
            <v-btn
              class="ma-0 text-xs-center"
              color="primary"
              @click="sendmail(); menuMail = false"
              type="submit"
            >
            Envoyer
            </v-btn>
          </v-form>
        </v-card-text>
      </v-card>
    </v-menu>

  </div>
</template>




<script>

import { mapState } from 'vuex';
import session from '../api/session';
// const qs = require('qs');

export default {
  data: function() {
    return {
      api_url: '/api/sendmail/',
      menuMail: false,
      helpTooltip: "Nous contacter",
      hinttext: "Contactez nous à propos de problèmes ou d'améliorations. Merci!",
      message: null,
      guestEmail: null,
    }
  },
  computed: {
    ...mapState('whoami', [
      'username',
      'email',
      'first_name',
      'last_name',
    ]),
    registered() {
      // Permet de savoir si l'on est loggé ou non.
      // Le but est d'afficher ou non un champ mail dans le formulaire de contact.
      if (this.email) {
        return true
      } else {
        return false
      }
    },
  },
  methods: {
    sendmail() {
      console.log('--- Envoi du mail ---')
      var req_url = this.api_url;
      var payload = {
        registered: this.registered, // si le user est enregistré dans l'app
        username: this.username,
        email: this.registered ? this.email : this.guestEmail,
        message: this.message
      }
      session.post(req_url, payload)
        .then((response) => {
          console.log('Mail envoyé');
          // console.log('code retour: ' + response.status + ' / ' + response.text)
          console.log('code retour: ' + response.status)
        })
        .catch((err) => {
          this.isLoading = false;
          if (err.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            console.log('======= Sendmail error in response =======')
            console.log(err.response.data);
            console.log(err.response.status);
            console.log(err.response.headers);
          } else if (err.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            console.log('======= Sendmail error in request =======')
            console.log(err.request);
          } else {
            // Something happened in setting up the request that triggered an Error
            console.log('======= Sendmail error in else =======')
            console.log('Err', err.message);
          }
        })

    }
  }
}



</script>
